(ns frontend.ui.component.lp-portal.modal.edit-modals.invest-europe.table-data-editor
  (:require
   [common.localization :as loc]
   [frontend.ui.component.lp-portal.modal.edit-modals.common :as common-components]
   [frontend.ui.component.lp-portal.modal.edit-modals.invest-europe.events :as events]
   [frontend.ui.component.lp-portal.modal.style :as style]
   [herb.core :as h]
   [ui.components.button.view :as button]
   [ui.editors.data-input :as data-input]))

(def column-data-type-options
  [{:value :table-data-type/text :label (loc/tr :text)}
   {:value :table-data-type/number :label (loc/tr :number)}
   {:value :table-data-type/currency :label (loc/tr :currency)}
   {:value :table-data-type/percentage :label (loc/tr :percentage)}
   {:value :table-data-type/multiple :label (loc/tr :multiple)}
   {:value :table-data-type/date :label (loc/tr :date)}])

(defn editable-table-header-row
  [state {:keys [header-data header-type row-idx fixed-labels? fixed-columns? column-typed?]}]
  (let [columns (:cols header-data)
        info-header? (= header-type :header-type/info)
        first-row? (= row-idx 0)]
    [:thead
     (into
      [:tr]
      (->> columns
           (map-indexed
            (fn [col-idx col]
              (let [value (str col)
                    first-col? (= col-idx 0)]
                ^{:key (str col-idx "/" (count columns))}
                [:th
                 {:class (h/<class style/table-header-cell-container)}
                 [:div
                  {:class (h/<class style/table-header-cell)
                   :id    "header-cell"}
                  [data-input/view
                   {:data-type :data.type/text-simple
                    :class     (h/<class style/table-header-input fixed-labels?)
                    :value     value
                    :on-change  #(events/update-heading! state row-idx col-idx %)
                    :disabled? fixed-labels?}]
                  (when-not (or info-header? fixed-columns?)
                    [common-components/header-dropdown
                     {:state state
                      :add-column-to-index-before! (when-not (and first-row? first-col?)
                                                     (fn
                                                       ([] (events/add-column-to-index! state col-idx))
                                                       ([data-type] (events/add-column-to-index! state col-idx data-type))))
                      :add-column-to-index-after! (fn
                                                    ([] (events/add-column-to-index! state (+ col-idx 1)))
                                                    ([data-type] (events/add-column-to-index! state (+ col-idx 1) data-type)))
                      :remove-column! (when-not first-col?
                                        #(events/remove-column! state col-idx))
                      :insert-column-type-options (when column-typed?
                                                    column-data-type-options)}])]])))))]))

(def arrow-select-options
  [{:value nil      :label "-"}
   {:value "\uf062" :label "Up"}
   {:value "\uf061" :label "Right"}
   {:value "\uf060" :label "Left"}
   {:value "\uf063" :label "Down"}])


(defn icon-cell-controls
  [{:keys [state row-idx col-idx disabled?]}]
  (let [r     (inc row-idx)
        path  [:original-data :icon-config-table r col-idx]
        ui    [:ui :icon-config-open r col-idx]                  
        cfg   (get-in @state path)
        icon  (:icon cfg)
        color (:color cfg)
        open? (true? (get-in @state ui))]
    [:div {:style {:display "flex" :align-items "center" :gap "6px" :margin-top "4px"}}
     
     (when icon
       [:span {:style {:font-family "FontAwesome"
                       :color (or color "#000000")}
               :class "text-base"}
        icon])
     
     (when (and open? (not disabled?))
       [:div {:class "ml-auto flex items-center gap-2 px-2 py-1
                      bg-slate-50 ring-1 ring-slate-200 rounded-md shadow-sm"}
        [:input {:type "color"
                 :disabled (nil? icon)
                 :value (or color "#000000")
                 :on-change (fn [e]
                              (swap! state assoc-in
                                     path
                                     (assoc (or cfg {:icon icon})
                                            :color (.. e -target -value))))
                 :class "w-10 h-10 p-0 border border-gray-300 rounded"}]
        [data-input/view
         {:data-type   :data.type/text-simple
          :editor-type :editor.type/select
          :small? true
          :class "w-24 min-w-0 px-2 leading-tight text-xs"
          :label "Icon"
          :disabled? false
          :value icon
          :options arrow-select-options
          :on-change (fn [new-val _]
                       (swap! state assoc-in path
                              (when new-val
                                {:icon  new-val
                                 :color (or color "#000000")})))}]])
     [button/square-secondary-hollow
      {:disabled disabled?
       :tooltip (if open? "Hide icon settings" "Add icon")
       :on-click #(swap! state assoc-in ui (not open?))
       :class "ml-1 w-6 h-6 rounded border border-gray-300 text-gray-700 text-xs leading-none
                flex items-center justify-center hover:bg-gray-50 disabled:opacity-50"}
      (if open? "×" "+")]]))

(defn editable-table-row-by-data-type
  [{:keys [state row-data-type row-type row-idx row-data row-type-options
           no-headers? first-col-fixed? fixed-rows? disable-heading-edit?]}]
  (let [header-row? (some #{row-type} ["heading" "heading info" "subheading"])
        disable-heading-edit? (and header-row? disable-heading-edit?)
        data-cell-not-editable? header-row?
        col-data-types (get-in @state [:original-data :column-data-types])
        data-types-by-column (if col-data-types
                              col-data-types
                              (repeat (count row-data) row-data-type))
        first-row? (= row-idx 0)
        table-cell-icons? (seq (get-in @state [:original-data :icon-config-table]))]
    (->> row-data
         (map-indexed
          (fn [col-idx col]
            (let [col-data-type (when (= (count row-data)
                                         (count data-types-by-column))
                                  (nth data-types-by-column col-idx))
                  edit-as-text? (or (nil? col-data-type)
                                    (some #{col-data-type} [:table-data-type/text]))]
              ^{:key (str col-idx "/" (count row-data) "/" (count (get-in @state [:original-data :rows])))}
              [:td
               {:class (h/<class style/table-editor-cell (not (= col-idx 0)))}
               (if (= col-idx 0)
                 [:div
                  {:class (h/<class style/first-col-cell-container)}
                  [:div
                   {:class (h/<class style/table-header-cell)
                    :id    "header-cell"}
                   [data-input/view
                    {:data-type :data.type/text-simple
                     :class     (h/<class style/table-header-input (not first-col-fixed?))
                     :value     (str col)
                     :on-change  #(events/update-value!
                                   state
                                   row-idx
                                   col-idx
                                   %)
                     :disabled? (or disable-heading-edit? first-col-fixed?)}]
                   (when-not fixed-rows?
                     [common-components/row-dropdown
                      {:state state
                       :row-idx row-idx
                       :add-row-to-index-before! (when-not (and no-headers? first-row?)
                                                   (fn
                                                     ([] (events/add-row-to-index! state row-idx))
                                                     ([data-type] (events/add-row-to-index! state row-idx data-type))))
                       :add-row-to-index-after! (fn
                                                  ([] (events/add-row-to-index! state (+ row-idx 1)))
                                                  ([data-type] (events/add-row-to-index! state (+ row-idx 1) data-type)))
                       :remove-row! (when-not (and no-headers? first-row?)
                                      #(events/remove-row! state row-idx))
                       :insert-row-type-options row-type-options}])]]
                 [:div
                  {:style {:padding         "4px 8px 4px 8px"
                           :display         "flex"
                           :align-items     "center"
                           :justify-content "flex-end"
                           :gap             "2px"}}
                  [data-input/view
                   {:data-type (cond edit-as-text?
                                     :data.type/text-simple
                                     (= col-data-type :table-data-type/date)
                                     :data.type/date
                                     :else
                                     :data.type/number)
                    :class     (h/join (h/<class style/number-input)
                                       #_(h/<class style/full-width))
                    :value     col
                    :variant   :borderless
                    :disabled? data-cell-not-editable?
                    :on-change #(events/update-value! state row-idx col-idx %)}]
                 
                  (when (and table-cell-icons? (not data-cell-not-editable?))
                    [icon-cell-controls {:state state
                                         :row-idx row-idx
                                         :col-idx col-idx
                                         :disabled? data-cell-not-editable?}])])]))))))

(defn editable-table-with-configurations
  [{:keys [state no-columns? fixed-labels? fixed-columns? fixed-rows?
           first-col-fixed? disable-heading-edit?]}]
  (let [rows (get-in @state [:original-data :rows])
        headers (get-in @state [:original-data :headers])
        no-headers? (not (seq headers))
        block-table? (:block-table? @state)
        column-data-types (get-in @state [:original-data :column-data-types])
        row-typed? (and (not block-table?)
                        (not (seq column-data-types))
                        (->> rows
                             (some #(some? (:row-data-types %)))))
        column-typed? (and (not block-table?)
                           (seq column-data-types))
        row-type-options (when row-typed?
                           column-data-type-options)]
    [:table
     {:class (h/<class style/table)}
     (->> headers
          (map-indexed (fn [row-idx header]
                         (let [header-type (:header-type header)]
                           [editable-table-header-row state
                            {:header-data header
                             :header-type header-type
                             :row-idx row-idx
                             :no-columns?    no-columns?
                             :fixed-labels?  fixed-labels?
                             :fixed-columns? fixed-columns?
                             :column-typed?  column-typed?}]))))
     (if-not (seq rows)
       [button/secondary-hollow
        {:on-click #(events/add-row-to-index! state 0 :table-data-type/text)}
        (loc/tr :no-chart-data-available-row)]
       (into [:tbody]
             (->> rows
                  (map-indexed
                   (fn [row-idx row]
                     (let [row-data (:row-data row)
                           row-data-type (:row-data-types row)
                           row-type (:row-type row)
                           row-font-style (:row-font-style row)]
                       ^{:key (str (count rows) "-" row-idx)}
                       (into [:tr]
                             (editable-table-row-by-data-type {:state state
                                                               :row-data-type row-data-type
                                                               :row-type row-type
                                                               :row-idx row-idx
                                                               :row-data row-data
                                                               :row-font-style row-font-style
                                                               :row-type-options row-type-options
                                                               :no-headers? no-headers?
                                                               :first-col-fixed? first-col-fixed?
                                                               :fixed-rows? fixed-rows?
                                                               :disable-heading-edit? disable-heading-edit?}))))))))]))
